import { render, staticRenderFns } from "./ProductStocksTable.vue?vue&type=template&id=58299ec3&scoped=true&"
import script from "./ProductStocksTable.vue?vue&type=script&lang=ts&"
export * from "./ProductStocksTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58299ec3",
  null
  
)

export default component.exports